import React from 'react'
import { currentLocale } from '../locale'
import "../style/sign.scss"
import Card from '../components/Card'

export const NotFound = () => (
    <nav className="level">
        <div className="level-item ">
            <div className="notification">
                <p className="subtitle has-text-centered">{currentLocale.notFound}</p>
                <br />
                <br />
                <br />
            </div>
        </div>
    </nav>
)




